import {
  CopyButton,
  Tooltip,
  UnstyledButton,
  useMantineColorScheme,
  type UnstyledButtonProps,
} from "@mantine/core"
import { useHover } from "@mantine/hooks"
import { MRT_Cell, MRT_CellValue, MRT_RowData } from "mantine-react-table"
import { type ReactNode } from "react"

interface Props<TData extends MRT_RowData, TValue = MRT_CellValue>
  extends UnstyledButtonProps {
  cell?: MRT_Cell<TData, TValue>
  children: ReactNode
  value?: string
}

export const CustomCopyCellButton = <TData extends MRT_RowData>({
  cell,
  children,
  value,
}: Props<TData>) => {
  const { colorScheme } = useMantineColorScheme()
  const { hovered, ref } = useHover()
  return (
    <CopyButton value={value ?? cell?.getValue<string>() ?? ""}>
      {({ copied, copy }) => (
        <Tooltip
          color={
            copied ? (colorScheme === "dark" ? "teal" : "green") : undefined
          }
          label={copied ? "Copied to clipboard" : "Click to copy"}
          withinPortal
          openDelay={1}
        >
          <UnstyledButton
            ref={ref}
            onClick={(e) => {
              e.stopPropagation()
              copy()
            }}
            bg={hovered ? "surfaceSelected" : ""}
            bdrs={4}
            px={8}
            py={4}
            style={{
              cursor: "default",
            }}
          >
            {children}
          </UnstyledButton>
        </Tooltip>
      )}
    </CopyButton>
  )
}
